import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
} from '@angular/core';
import { PreviewService } from './preview.service';

@Component({
  selector: 'ui-preview',
  standalone: true,
  imports: [],
  templateUrl: './preview.component.html',
  styleUrl: './preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewComponent {
  protected readonly previewService = inject(PreviewService);

  @HostListener('document:keydown.escape', ['$event'])
  protected closeByEscape(event: Event): void {
    if (!this.previewService.preview()) {
      return;
    }

    (event as KeyboardEvent).stopImmediatePropagation();

    this.previewService.deletePreview();
  }
}
